
import * as Yup from 'yup';

import { useState,forwardRef } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
// material
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Dialog, DialogTitle, DialogActions, DialogContentText, DialogContent,
  Button,
  Slide


} from '@mui/material';
import { LoadingButton } from '@mui/lab';


import { useAuth } from '../../customContextProviders/AuthContext';
import { ResetPassword } from '../../../network/User';
import AlertDialog from '../../AlertDialog';
import {parseValidationErrorMessage} from '../../../utils/Utilities'

/* eslint-disable */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



export default function ForgetPasswordForm({token}) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const {authenticateSession}=useAuth()




  const [errorData, setErrorData] = useState({
    visible: false,
    message: "",
    title:""
  })

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const LoginSchema = Yup.object().shape({
    // email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
    confirmPassword: Yup.string().required('Password is required')

  });

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: ''
    },
    validationSchema: LoginSchema,
    onSubmit: () => {
      if(formik.values.password !== formik.values.confirmPassword){
        setAlertDialogMetas({ ...alertDialogMetas, message: "Password and confirm password doesn't match", title: "", btnLabel: "OK" });
        setOpenAlertDialog(true)
        formik.setSubmitting(false)
        return

      }

      ResetPasswordRequest( token,formik.values.password,);
    }
  });

  const handleAlertDialogClose = () => {
    setErrorData({ ...errorData, visible: false, message: "" })
  }

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  const handleShowPassword = () => {
    setShowPassword((show) => !show);
  };

  function ResetPasswordRequest(token, password) {
    ResetPassword(token,password).then((res)=>{
      
      formik.setSubmitting(false)
      setAlertDialogMetas({ ...alertDialogMetas, message: "Your password has been changed successfully !", title: "", btnLabel: "OK" });
      setOpenAlertDialog(true)

      setTimeout(()=>{
        navigate('/login', { replace: true });
      },3000)

    }).catch((err)=>{
      formik.setSubmitting(false)
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: "Failed to process your request", btnLabel: "OK" });
      setOpenAlertDialog(true)
    })


   
  }



  return (
    <div>
      <FormikProvider value={formik}>
        <Form autoComplete="off"  noValidate onSubmit={handleSubmit}>
          <Stack spacing={3}>
           
          <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              {...getFieldProps('password')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.password && errors.password)}
              helperText={touched.password && errors.password}
            />

            <TextField
              fullWidth
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              label="Confirm Password"
              {...getFieldProps('confirmPassword')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleShowPassword} edge="end">
                      <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={Boolean(touched.confirmPassword && errors.confirmPassword)}
              helperText={touched.confirmPassword && errors.confirmPassword}
            />
          </Stack>

         

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={isSubmitting}
            sx={{mt:3}}
          >
            Login
          </LoadingButton>
        </Form>
      </FormikProvider>

      <Dialog
        open={errorData?.visible}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleAlertDialogClose()}
        aria-describedby="iot_res_alert-dialog-slide-description"
      >
        <DialogTitle>{errorData?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="aiot_res_alert-dialog-slide-description">
            {errorData?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button onClick={() => handleAlertDialogClose()}>OK</Button>
        </DialogActions>
      </Dialog>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />
    </div>
  );
}
